import React from "react";
import Ample from "../components/ample/ample";
import {useSiteMetadata,Mailto} from "../branding";



const ContactUsPage = (props) => {
  const siteMetadata = useSiteMetadata();
  
  return (
      <Ample currPageTitle="Contact Us" seoDescription="Contact Us" location={props.location.href} >
        <div className="white-box">
          <div className="box-title" style={{textTransform: 'none'}}>Contact Us</div>
          <p style={{color: "#666", fontSize: "0.95rem", marginTop: "12px"}}>
          Help us make this site better.  Send any feedback, suggestions, or ideas to:&nbsp;
          <Mailto email="tradingsolutions@harsip.com" subject={`${siteMetadata.title} feedback`} >
            tradingsolutions@harsip.com
          </Mailto>
          </p>
        </div>
      </Ample>);
  
};

export default ContactUsPage;